import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import config from '../i18n.config.json';

type LanguageResource = {
  [key: string]: {
    translation: {
      [key: string]: string
    }
  };
}

const resources: LanguageResource = {};

(async() => {
  await Promise.all(
    config.languages.map(async(lng: string) => {
      resources[lng] = {
        translation: await import(`./i18n/${lng}.json`),
      };
    })
  );
})();

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });
